import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: _idEmisor =>
    api
      .send({
        query: gql`
          query readByEmisor($_idEmisor: ID!) {
            Account {
              readByEmisor(_idEmisor: $_idEmisor) {
                _id
                _idAccountType
                name
                sysName
                code
                state

                accountType {
                  _id
                  report
                  category
                  type
                  code
                }

                # createdAt
                # updatedAt
              }
            }
          }
        `,
        variables: {
          _idEmisor
        }
      })
      .then(result => result.data.data.Account.readByEmisor),
  readAllTypesByEmisor: _idEmisor =>
    api
      .send({
        query: gql`
          query readByEmisor($_idEmisor: ID!) {
            AccountType {
              readByEmisor(_idEmisor: $_idEmisor) {
                _id
                report
                category
                type
                code
              }
            }
          }
        `,
        variables: {
          _idEmisor
        }
      })
      .then(result => result.data.data.AccountType.readByEmisor),
  readByEmisor: _idEmisor =>
    api
      .send({
        query: gql`
          query readByEmisor($_idEmisor: ID!) {
            Currency {
              readByEmisor(_idEmisor: $_idEmisor) {
                # _id
                # currency este valor está en el emisor
                exchanges {
                  _id
                  rate
                  auto
                  date
                }
              }
            }
          }
        `,
        variables: {
          _idEmisor
        }
      })
      .then(result => result.data.data.Currency.readByEmisor),

  // tipos de cuentas default
  setDefaults: _idEmisor =>
    api
      .send({
        query: gql`
          mutation setDefaults($_idEmisor: ID!) {
            AccountType {
              setDefaults(_idEmisor: $_idEmisor) {
                _id
                report
                category
                type
                code

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          _idEmisor
        }
      })
      .then(result => result.data.data.AccountType.setDefaults),

  // catalogo de cuentas default
  setDefaultsAccounts: _idEmisor =>
    api
      .send({
        query: gql`
          mutation setDefaults($_idEmisor: ID!) {
            Account {
              setDefaults(_idEmisor: $_idEmisor) {
                _id
                _idAccountType
                name
                code
                state

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          _idEmisor
        }
      })
      .then(result => result.data.data.Account.setDefaults)
}
